/** Common issue categories offered in the thumbs-down feedback dialog. */
export const FEEDBACK_ISSUE_TYPES = [
  'Does not answer my question',
  'Results contradict data',
  'Ignored on-screen filters',
  'Incorrect insight provided',
] as const;
